// extracted by mini-css-extract-plugin
export var actionIcon = "_o9-0";